import {DISTANCE_VALUES, DISTANCE_VALUES_ODONTO} from '../ui/components/DistanceSlider/constants';

const KM_TO_REFETCH = '25';
const MIN_DISTANCE_IN_KM = '0';
const MAX_DISTANCE_FILTER_UNITS = DISTANCE_VALUES.at(-1) as number;
const MAX_DISTANCE_FILTER_UNITS_ODONTO = DISTANCE_VALUES_ODONTO.at(-1) as number;
const MIN_DISTANCE_TO_FETCH_ODONTO_UNITS = '5';
const MAX_DISTRICT_FILTER_COUNT = 100;
const MANUAL_DISTANCE_ORIGIN = 'manual';

export {
	KM_TO_REFETCH,
	MIN_DISTANCE_IN_KM,
	MAX_DISTANCE_FILTER_UNITS,
	MAX_DISTANCE_FILTER_UNITS_ODONTO,
	MIN_DISTANCE_TO_FETCH_ODONTO_UNITS,
	MAX_DISTRICT_FILTER_COUNT,
	MANUAL_DISTANCE_ORIGIN,
};
